import React, { Component } from 'react'
import {
    Form,
    Row,
    Col,
    Input, InputNumber, Select, Checkbox,
    Button, Table, Popconfirm, Modal, Radio,
    Icon, Card,
    Collapse
} from 'antd';
import { uuid } from '../../common/CommonFunc'
import { UserModal } from '../../common/UserModal'
import  PubInfo  from '../../Component/PubInfo'
const FormItem = Form.Item;
const Panel = Collapse.Panel;
const Option = Select.Option;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;

class EndeNodeFrom extends Component {
    constructor(props) {
        super(props)

        this.state = {
            node: props.node,
            show: props.show != null && props.show == true ? props.show : 'none',
            nodedata: props.nodedata,
			modalServiceInShow: false,
			modalServiceOutShow: false,
			modalServiceCbInShow: false,
			modalServiceCbOutShow: false,
			modalScriptInShow: false,
			modalScriptOutShow: false,

            loading: false
        }
    }

    // 重新加载页面方法
    reload = () => {
        this.setState({ loading: false });
    }
    // 文本修改事件
    textOnChange(attname, e, e2) {
        tool.sgiLogger.log("事件：textOnChange")
        let value = e.target.value;
        this.refresh(attname, value);
    }
    // 下拉窗修改事件
    selectOnChange = (attname, value) => {//change传入对象为value
        tool.sgiLogger.log("事件：selectOnChange")
        this.refresh(attname, value);
    }
    // 复选框组修改事件，checkedValue为数组["01","02"]
    checkboxGroupOnChange = (attname, checkedValue) => {
        tool.sgiLogger.log("事件：checkboxGroupOnChange")
        this.refresh(attname, checkedValue);
    }
    // 数字组件修改事件
    numberOnChange(attname, e) {
        tool.sgiLogger.log("事件：numberOnChange")
        let value = e;
        this.refresh(attname, value);
    }
    // 单选框组修改事件
    radioGroupOnChange(attname, e) {
        tool.sgiLogger.log("事件：radioGroupOnChange")
        let value = e.target.value;
        this.refresh(attname, value);
    }
    // 属性更新
    refresh(attname, value) {
        if (attname === 'name' && this.state.nodedata[attname] != value) this.state.node.setText(this.state.node.data.id+" "+value);
        this.state.nodedata[attname] = value;
    }

// 输入参数modal确认按钮事件
serviceCallInHandleOk = (e) => {
    const newData = {
        inParamKey: this.state.inParamKey,
        inParamValue: this.state.inParamValue,
    };
    if (typeof(this.state.nodedata.servicecallin)=="undefined") { 
        this.state.nodedata.servicecallin=[];
    }
    const { servicecallin } = this.state.nodedata;
    this.state.nodedata.servicecallin = [...servicecallin, newData]
    this.state.modalServiceInShow = false;
    this.setState({
        loading: false,
    });
}
// 服务输出参数modal确认按钮事件
serviceCallOutHandleOk = (e) => {
    const newData = {
        outParamKey: this.state.outParamKey,
        outParamValue: this.state.outParamValue,
    };
    if (typeof(this.state.nodedata.servicecallout)=="undefined") { 
        this.state.nodedata.servicecallout=[];
    }
    const { servicecallout } = this.state.nodedata;
    this.state.nodedata.servicecallout = [...servicecallout, newData]
    this.state.modalServiceOutShow = false;
    this.setState({
        loading: false,
    });
}

// 回调输入参数modal确认按钮事件
serviceCallbackInHandleOk = (e) => {
    const newData = {
        inParamKey: this.state.inParamKey,
        inParamValue: this.state.inParamValue,
    };
    if (typeof(this.state.nodedata.servicecallbackin)=="undefined") { 
        this.state.nodedata.servicecallbackin=[];
    }
    const { servicecallbackin } = this.state.nodedata;
    this.state.nodedata.servicecallbackin = [...servicecallbackin, newData]
    this.state.modalServiceCbInShow = false;
    this.setState({
        loading: false,
    });
}


// 回调服务输出参数modal确认按钮事件
serviceCallbackOutHandleOk = (e) => {
    const newData = {
        outParamKey: this.state.outParamKey,
        outParamValue: this.state.outParamValue,
    };
    if (typeof(this.state.nodedata.servicecallbackout)=="undefined") { 
        this.state.nodedata.servicecallbackout=[];
    }
    const { servicecallbackout } = this.state.nodedata;
    this.state.nodedata.servicecallbackout = [...servicecallbackout, newData]
    this.state.modalServiceCbOutShow = false;
    this.setState({
        loading: false,
    });
}// 输入参数modal取消按钮事件

modalHandleCancel = (e) => {
    this.setState({
        modalShow: false,
    });
    
            this.state.modalScriptInShow = true;
            this.setState({ modalServiceInShow: false,modalServiceCbInShow: false,modalServiceOutShow: false,modalServiceCbOutShow: false,modalServiceOutShow: false,modalScriptOutShow: false  });
}
// modal中文本框修改事件
modalOnChange = (attname, e, e2) => {
    tool.sgiLogger.log("事件：modalOnChange")
    let value = e.target.value;
    this.state[attname] = value;
}
// 输入参数modal确认按钮事件
	scriptCallInHandleOk = (e) => {
		const newData = {
			inParamKey: this.state.inParamKey,
			inParamValue: this.state.inParamValue,
		};
        if (typeof(this.state.nodedata.scriptcallin)=="undefined") { 
            this.state.nodedata.scriptcallin=[];
        }
        const { scriptcallin } = this.state.nodedata;
		this.state.nodedata.scriptcallin = [...scriptcallin, newData]
		this.state.modalScriptInShow = false;
		this.setState({
			loading: false,
		});
	}
	// 输出参数modal确认按钮事件
	scriptCallOutHandleOk = (e) => {
		const newData = {
			outParamKey: this.state.outParamKey,
			outParamValue: this.state.outParamValue,
		};
        if (typeof(this.state.nodedata.scriptcallout)=="undefined") { 
            this.state.nodedata.scriptcallout=[];
        }
        const { scriptcallout } = this.state.nodedata;
		this.state.nodedata.scriptcallout = [...scriptcallout, newData]
		this.state.modalScriptOutShow = false;
		this.setState({
			loading: false,
		});
	}
    // 表格添加方法
    handleAdd = (modalType) => {
        tool.sgiLogger.log("handleAdd表格添加方法");
        if (!modalType || modalType == '') {
            this.state.modalContent = null;;
        }
        if (modalType == "servicecallin") {
            this.state.modalServiceInShow = true;
        } else if (modalType == "servicecallbackin") {
            this.state.modalServiceCbInShow = true;
        } else if (modalType == "servicecallout") {
            this.state.modalServiceOutShow = true;
        } else if (modalType == "servicecallbackout") {
            this.state.modalServiceCbOutShow = true;
        }else if (modalType == "scriptcallin") {
            this.state.modalScriptInShow = true;
        } else if (modalType == "scriptcallout") {
            this.state.modalScriptOutShow = true;
        }
        if (modalType == 'human') {
            this.state.modalContent = <UserModal key={uuid(8)} modalShow={true} title="选择操作人员"
                approvalUserList={this.state.nodedata.human} parent={this} />
        }
        this.setState({
            loading: false
        });
    }
    // 表格添加方法
    // handleAdd = (modalType) => {
    //     tool.sgiLogger.log("handleAdd表格添加方法");
    //     if (!modalType || modalType == '') {
    //         this.state.modalContent = null;;
    //     }
    //     if (modalType == 'human') {
    //         this.state.modalContent = <UserModal key={uuid(8)} modalShow={true} title="选择操作人员"
    //             approvalUserList={this.state.nodedata.human} parent={this} />
    //     }
    //     this.setState({
    //         loading: false
    //     });
    // }
    // 表格删除方法
    handleDelete = (delData, dataSource) => {
        if (dataSource && delData) {
            for (var i = 0; i < dataSource.length; i++) {
                if (delData == dataSource[i] || delData._key == dataSource[i]._key) {
                    dataSource.splice(i, 1);
                }
            }
        }
        this.setState({ loading: false });
    }
    // 创建表格绑定store（生成数据key）
    getTBData = (tData) => {
        if (!tData) {
            tData = [];
            return tData;
        }
        tData.forEach(element => {
            if (!element._key) element._key = uuid(8);
        })
        return tData;
    }

    // 刷新form
    componentDidMount() {
        tool.sgiLogger.log('事件：endNode加载后')
        this.props.form.setFieldsValue({
            // id: this.state.nodedata.id,
            // name: this.state.nodedata.name,
            // type: this.state.nodedata.type,
            // status: this.state.nodedata.status,
            // inCondition: this.state.nodedata.inCondition,
            // outCondition: this.state.nodedata.outCondition,
            // ann: this.state.nodedata.ann,

			end: this.state.nodedata.end,
			endtype: this.state.nodedata.endtype,
            gototype: this.state.nodedata.gototype,
			gotoInterface: this.state.nodedata.gotoInterface,
			gotoInterfaceparm: this.state.nodedata.gotoInterfaceparm,

            //service 调用
			serviceUrl: this.state.nodedata.serviceUrl,
			serviceprotocol: this.state.nodedata.serviceprotocol,
			serviceprocessor: this.state.nodedata.serviceprocessor,
			servicecallio: this.state.nodedata.servicecallio,

			serviceAcynctype: this.state.nodedata.serviceAcynctype,
			servicecalltype: this.state.nodedata.servicecalltype,
			servicetimeout: this.state.nodedata.servicetimeout,
			servicecallback: this.state.nodedata.servicecallback,
            servicecallbackio: this.state.nodedata.servicecallbackio,
            
			
			servicereceiveTimeout: this.state.nodedata.servicereceiveTimeout,
			servicetimeoutHandling: this.state.nodedata.servicetimeoutHandling,
            serviceredoServiceUrl: this.state.nodedata.serviceredoServiceUrl,
            
            //执行脚本
			scripttype: this.state.nodedata.scripttype,
			scriptcode: this.state.nodedata.scriptcode,
			scriptcallin: this.state.nodedata.scriptcallin,
			scriptcallout: this.state.nodedata.scriptcallout,

            ishuman: this.state.nodedata.ishuman,
            receiveTimeoutHandling: this.state.nodedata.receiveTimeoutHandling,
            human: this.state.nodedata.human
        });
    }


    render() {
        const { getFieldDecorator } = this.props.form;
        const servicecallinList = this.getTBData(this.state.nodedata.servicecallin);
		const servicecallinListColumns = [
			{
				title: '输入参数key', // 列头显示名称
				dataIndex: 'inParamKey' // 列数据在数据项中对应的 key
			},
			{
				title: '输入参数值', // 列头显示名称
				dataIndex: 'inParamValue' // 列数据在数据项中对应的 key
			},
			{
				title: '操作',
				key: 'action',
				render: (text, record) => (
					this.state.nodedata.servicecallin.length >= 1
						? (
							<Popconfirm title="确认删除?" onConfirm={() => this.handleDelete(record, this.state.nodedata.servicecallin)}>
								<a href="javascript:;">删除</a>
							</Popconfirm>
						) : null
				),
			}
		];
		const servicecallbackinList = this.getTBData(this.state.nodedata.servicecallbackin);
		const servicecallbackinListColumns = [
			{
				title: '输入参数key', // 列头显示名称
				dataIndex: 'inParamKey' // 列数据在数据项中对应的 key
			},
			{
				title: '输入参数值', // 列头显示名称
				dataIndex: 'inParamValue' // 列数据在数据项中对应的 key
			},
			{
				title: '操作',
				key: 'action',
				render: (text, record) => (
					this.state.nodedata.servicecallbackin.length >= 1
						? (
							<Popconfirm title="确认删除?" onConfirm={() => this.handleDelete(record, this.state.nodedata.servicecallbackin)}>
								<a href="javascript:;">删除</a>
							</Popconfirm>
						) : null
				),
			}
        ];

        const servicecalloutList = this.getTBData(this.state.nodedata.servicecallout);
		const servicecalloutListColumns = [
			{
				title: '输出参数key', // 列头显示名称
				dataIndex: 'outParamKey' // 列数据在数据项中对应的 key
			},
			{
				title: '输出参数值', // 列头显示名称
				dataIndex: 'outParamValue' // 列数据在数据项中对应的 key
			},
			{
				title: '操作',
				key: 'action',
				render: (text, record) => (
					this.state.nodedata.servicecallout.length >= 1
						? (
							<Popconfirm title="确认删除?" onConfirm={() => this.handleDelete(record, this.state.nodedata.servicecallout)}>
								<a href="javascript:;">删除</a>
							</Popconfirm>
						) : null
				),
			}
		];
		const servicecallbackoutList = this.getTBData(this.state.nodedata.servicecallbackout);
		const servicecallbackoutListColumns = [
			{
				title: '输出参数key', // 列头显示名称
				dataIndex: 'outParamKey' // 列数据在数据项中对应的 key
			},
			{
				title: '输出参数值', // 列头显示名称
				dataIndex: 'outParamValue' // 列数据在数据项中对应的 key
			},
			{
				title: '操作',
				key: 'action',
				render: (text, record) => (
					this.state.nodedata.servicecallbackout.length >= 1
						? (
							<Popconfirm title="确认删除?" onConfirm={() => this.handleDelete(record, this.state.nodedata.servicecallbackout)}>
								<a href="javascript:;">删除</a>
							</Popconfirm>
						) : null
				),
			}
        ];

        const scriptcallinList = this.getTBData(this.state.nodedata.scriptcallin);
		const scriptcallinListColumns = [
			{
				title: '输入参数key', // 列头显示名称
				dataIndex: 'inParamKey' // 列数据在数据项中对应的 key
			},
			{
				title: '输入参数值', // 列头显示名称
				dataIndex: 'inParamValue' // 列数据在数据项中对应的 key
			},
			{
				title: '操作',
				key: 'action',
				render: (text, record) => (
					this.state.nodedata.scriptcallin.length >= 1
						? (
							<Popconfirm title="确认删除?" onConfirm={() => this.handleDelete(record, this.state.nodedata.scriptcallin)}>
								<a href="javascript:;">删除</a>
							</Popconfirm>
						) : null
				),
			}
		];
		const scriptcalloutList = this.getTBData(this.state.nodedata.scriptcallout);
		const scriptcalloutListColumns = [
			{
				title: '输出参数key', // 列头显示名称
				dataIndex: 'outParamKey' // 列数据在数据项中对应的 key
			},
			{
				title: '输出参数值', // 列头显示名称
				dataIndex: 'outParamValue' // 列数据在数据项中对应的 key
			},
			{
				title: '操作',
				key: 'action',
				render: (text, record) => (
					this.state.nodedata.scriptcallout.length >= 1
						? (
							<Popconfirm title="确认删除?" onConfirm={() => this.handleDelete(record, this.state.nodedata.scriptcallout)}>
								<a href="javascript:;">删除</a>
							</Popconfirm>
						) : null
				),
			}
		];
       
        const human = this.getTBData(this.state.nodedata.human);
		const interventionUserListColumns = [
			{
				title: '用户名称', // 列头显示名称
				dataIndex: 'empName' // 列数据在数据项中对应的 key
			},
			{
				title: '操作',
				key: 'action',
				render: (text, record) => (
					this.state.nodedata.human.length >= 1
						? (
							<Popconfirm title="确认删除?" onConfirm={() => this.handleDelete(record, this.state.nodedata.human)}>
								<a href="javascript:;">删除</a>
							</Popconfirm>
						) : null
				),
			}
        ];

        return (
            <div style={{ display: this.state.show }}>
                <Form layout="vertical" >
                    <Collapse defaultActiveKey={['1']} >
                    <Panel header="通用节点信息" key="1">
                            <PubInfo parent={this} node={this.state.node} nodedata={this.state.nodedata}/>
                        </Panel>
                        
                        <Panel header="结束节点信息" key="2">
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item label="结束处理">
                                        {getFieldDecorator('end', {
                                            rules: [{ required: false, message: '' }],
                                        })(
                                            <RadioGroup onChange={this.radioGroupOnChange.bind(this, 'end')} >
                                                <Radio value={"0"}>无</Radio>
                                                <Radio value={"1"}>有</Radio>
                                            </RadioGroup>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            {this.state.nodedata.end == "1" ?
                            <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item label="界面跳转">
                                    {getFieldDecorator('gototype', {
                                        rules: [{ required: false, message: '' }],
                                    })(
                                        <RadioGroup onChange={this.radioGroupOnChange.bind(this, 'gototype')} >
                                            <Radio value={"0"}>否</Radio>
                                            <Radio value={"1"}>是</Radio>
                                        </RadioGroup>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        :""}
                            
                            {this.state.nodedata.end == "1" &&this.state.nodedata.gototype == "1" ?
                            <Row gutter={16}>
								<Col span={24}>
									<Form.Item label="跳转界面">
										{getFieldDecorator('gotoInterface', {
											rules: [{ required: false, message: '请输入跳转界面' }],
										})(<Input placeholder="跳转界面"
											onChange={this.textOnChange.bind(this, 'gotoInterface')}
										/>)}
									</Form.Item>
								</Col>
							</Row>
                            :""}
                            {this.state.nodedata.end == "1" &&this.state.nodedata.gototype == "1" ?
							<Row gutter={16}>
								<Col span={24}>
									<Form.Item label="界面启动参数">
										{getFieldDecorator('gotoInterfaceparm', {
											rules: [{ required: false, message: '请输入界面启动参数' }],
										})(<Input placeholder="界面启动参数"
											onChange={this.textOnChange.bind(this, 'gotoInterfaceparm')}
										/>)}
									</Form.Item>
								</Col>
							</Row>
                            :""}
                            {this.state.nodedata.end == "1" ?
                            <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item label="处理类型">
                                    {getFieldDecorator('endtype', {
                                        rules: [{ required: false, message: '' }],
                                    })(
                                        <RadioGroup onChange={this.radioGroupOnChange.bind(this, 'endtype')} >
                                            <Radio value={"0"}>无</Radio>
                                            <Radio value={"1"}>调用服务</Radio>
                                            <Radio value={"2"}>执行脚本</Radio>
                                            <Radio value={"3"}>先执行脚本再调用服务</Radio>
                                            <Radio value={"4"}>先调用服务再执行脚本</Radio>
                                        </RadioGroup>
                                    )}
                                </Form.Item>
                            </Col>
                            </Row>
                            :""}
                        </Panel>
                            
                        {this.state.nodedata.end == "1" &&this.state.nodedata.endtype != "0" && this.state.nodedata.endtype != "2" && typeof(this.state.nodedata.endtype) !="undefined" ?
                        <Panel header="服务节点信息" key="3">
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item label="服务url">
                                        {getFieldDecorator('serviceUrl', {
                                            rules: [{ required: true, message: '请输入服务url' }],
                                        })(<Input placeholder="请输入服务url"
                                            onChange={this.textOnChange.bind(this, 'serviceUrl')}
                                        />)}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="通讯协议">
                                        {getFieldDecorator('serviceprotocol', {
                                            rules: [{ required: true, message: '请输入通讯协议' }],
                                        })(<Select placeholder="请输入通讯协议"
                                            onChange={this.selectOnChange.bind(this, 'serviceprotocol')}
                                        >
                                            <Option value="0">resful</Option>
                                            <Option value="1">xml</Option>
                                            <Option value="2">定长报文</Option>
                                            <Option value="3">8583报文</Option>
                                            <Option value="4">自定义报文</Option>
                                            <Option value="5">本地调用</Option>
                                        </Select>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item label="通讯处理程序">
                                        {getFieldDecorator('serviceprocessor', {
                                            rules: [{ required: false, message: '请输入通讯处理程序' }],
                                        })(<Input.TextArea rows={2} placeholder="请输入通讯处理程序"
                                            onChange={this.textOnChange.bind(this, 'serviceprocessor')}
                                        />)}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <div align="right">
                                        <Button size="small" onClick={this.handleAdd.bind(this, "servicecallin")} type="primary" style={{ marginBottom: 10 }}>
                                            添加服务输入
                                        </Button>
                                    </div>
                                    <Table size="small" rowKey={"_key"}
                                        rowClassName={() => 'incomeList-row'} // 表格行的类名
                                        bordered // 是否展示外边框和列边框
                                        dataSource={servicecallinList}
                                        columns={servicecallinListColumns}
                                    />
                                    <Modal
                                        title="添加服务输入参数"
                                        visible={this.state.modalServiceInShow}
                                        onOk={this.serviceCallInHandleOk.bind(this)}
                                        onCancel={this.modalHandleCancel}
                                        okText="确认"
                                        cancelText="取消"
                                        destroyOnClose
                                    >
                                        <Form.Item label="输入参数key">
                                            <Input placeholder="输入参数key"
                                                onChange={this.modalOnChange.bind(this, 'inParamKey')}
                                            />
                                        </Form.Item>
                                        <Form.Item label="输入参数value">
                                            <Input placeholder="输入参数value"
                                                onChange={this.modalOnChange.bind(this, 'inParamValue')}
                                            />
                                        </Form.Item>
                                    </Modal>
                                </Col>
                            </Row>
                            
                            <Row gutter={16}>
                                <Col span={24}>
                                    <div style={{color:"red"}}	>
                                        输出参数将保存在工作流的业务数据中
                                    </div>
                                    <div align="right">
                                        <Button size="small" onClick={this.handleAdd.bind(this, "servicecallout")} type="primary" style={{ marginBottom: 10 }}>
                                            添加服务输出
                                        </Button>
                                    </div>
                                    <Table size="small" rowKey={"_key"}
                                        rowClassName={() => 'incomeList-row'} // 表格行的类名
                                        bordered // 是否展示外边框和列边框
                                        dataSource={servicecalloutList}
                                        columns={servicecalloutListColumns}
                                    />
                                    <Modal
                                        title="添加服务输出参数"
                                        visible={this.state.modalServiceOutShow}
                                        onOk={this.serviceCallOutHandleOk.bind(this)}
                                        onCancel={this.modalHandleCancel}
                                        okText="确认"
                                        cancelText="取消"
                                        destroyOnClose
                                    >
                                        <Form.Item label="输出参数key">
                                            <Input placeholder="输出参数key"
                                                onChange={this.modalOnChange.bind(this, 'outParamKey')}
                                            />
                                        </Form.Item>
                                        <Form.Item label="输出参数value">
                                            <Input placeholder="输出参数value"
                                                onChange={this.modalOnChange.bind(this, 'outParamValue')}
                                            />
                                        </Form.Item>
                                    </Modal>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item label="调用方式">
                                        {getFieldDecorator('servicecalltype', {
                                            rules: [{ required: true, message: '' }],
                                        })(
                                            <RadioGroup onChange={this.radioGroupOnChange.bind(this, "servicecalltype")} >
                                                <Radio value={"0"}>同步</Radio>
                                                <Radio value={"1"}>异步</Radio>
                                            </RadioGroup>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item label="超时时间">
                                        {getFieldDecorator('servicetimeout', {
                                            initialValue: this.state.nodedata.timeout,
                                            rules: [{ required: false, message: '请输入超时时间' }],
                                        })(
                                            <InputNumber
                                                min={0}
                                                onChange={this.numberOnChange.bind(this, "servicetimeout")}
                                            />
                                        )}<span> 秒</span>
                                    </Form.Item>
                                </Col>
                            </Row>
                            
						    {this.state.nodedata.servicecalltype == "1" ?
									(
									<Row gutter={16}>
										<Col span={12}>
											<Form.Item label="异步回调方式">
												{getFieldDecorator('serviceAcynctype', {
													rules: [{ required: true, message: '' }],
												})(
													<RadioGroup onChange={this.radioGroupOnChange.bind(this, "serviceAcynctype")} >
														<Radio value={"1"}>回调接口</Radio>
														<Radio value={"2"}>消息通知</Radio>
													</RadioGroup>
												)}
											</Form.Item>
										</Col>
									</Row>)
							:""}
                            {
                                this.state.nodedata.servicecalltype == "9" ?
                                    (<Card>
                                       
										{this.state.nodedata.serviceAcynctype == "1" ?
										<Row gutter={16}>
											<Col span={24}>
												<Form.Item label="回调接口">
													{getFieldDecorator('servicecallbackUrl', {
														initialValue: this.state.nodedata.servicecallbackUrl,
														rules: [{ required: false, message: '请输入回调接口' }],
													})(<Input.TextArea rows={4} placeholder="请输入回调接口"
														onChange={this.textOnChange.bind(this, 'servicecallbackUrl')}
													/>)}
												</Form.Item>
											</Col>
										</Row>
										:""}
										
										{this.state.nodedata.serviceAcynctype == "2" ?
										<Row gutter={16}>
											<Col span={24}>
												<Form.Item label="自定义回调处理">
													{getFieldDecorator('servicecallbackUrl', {
														initialValue: this.state.nodedata.servicecallbackUrl,
														rules: [{ required: false, message: '请输入回调处理' }],
													})(<Input.TextArea rows={4} placeholder="请输入回调处理"
														onChange={this.textOnChange.bind(this, 'servicecallbackUrl')}
													/>)}
												</Form.Item>
											</Col>
										</Row>
                                        :""}
                                        {this.state.nodedata.serviceAcynctype != "0" ?
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div align="right">
                                                    <Button size="small" onClick={this.handleAdd.bind(this, "servicecallbackin")} type="primary" style={{ marginBottom: 10 }}>
                                                        添加回调服务输入
                                                    </Button>
                                                </div>
                                                <Table size="small" rowKey={"_key"}
                                                    rowClassName={() => 'incomeList-row'} // 表格行的类名
                                                    bordered // 是否展示外边框和列边框
                                                    dataSource={servicecallbackinList}
                                                    columns={servicecallbackinListColumns}
                                                />
                                                <Modal
                                                    title="添加回调服务输入参数"
                                                    visible={this.state.modalServiceCbInShow}
                                                    onOk={this.serviceCallbackInHandleOk.bind(this)}
                                                    onCancel={this.modalHandleCancel}
                                                    okText="确认"
                                                    cancelText="取消"
                                                    destroyOnClose
                                                >
                                                    <Form.Item label="输入参数key">
                                                        <Input placeholder="输入参数key"
                                                            onChange={this.modalOnChange.bind(this, 'inParamKey')}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item label="输入参数value">
                                                        <Input placeholder="输入参数value"
                                                            onChange={this.modalOnChange.bind(this, 'inParamValue')}
                                                        />
                                                    </Form.Item>
                                                </Modal>
                                            </Col>
                                        </Row>:""}
                                        {this.state.nodedata.serviceAcynctype != "0" ?
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div style={{color:"red"}}	>
                                                    输出参数将保存在工作流的业务数据中
                                                </div>
                                                <div align="right">
                                                    <Button size="small" onClick={this.handleAdd.bind(this, "servicecallbackout")} type="primary" style={{ marginBottom: 10 }}>
                                                        添加回调服务输入
                                                    </Button>
                                                </div>
                                                <Table size="small" rowKey={"_key"}
                                                    rowClassName={() => 'incomeList-row'} // 表格行的类名
                                                    bordered // 是否展示外边框和列边框
                                                    dataSource={servicecallbackoutList}
                                                    columns={servicecallbackoutListColumns}
                                                />
                                                <Modal
                                                    title="添加服务输出参数"
                                                    visible={this.state.modalServiceCbOutShow}
                                                    onOk={this.serviceCallbackOutHandleOk.bind(this)}
                                                    onCancel={this.modalHandleCancel}
                                                    okText="确认"
                                                    cancelText="取消"
                                                    destroyOnClose
                                                >
                                                    <Form.Item label="输出参数key">
                                                        <Input placeholder="输出参数key"
                                                            onChange={this.modalOnChange.bind(this, 'outParamKey')}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item label="输出参数value">
                                                        <Input placeholder="输出参数value"
                                                            onChange={this.modalOnChange.bind(this, 'outParamValue')}
                                                        />
                                                    </Form.Item>
                                                </Modal>
                                            </Col>
                                        </Row>:""}
                                    </Card>)
							:""}
                        </Panel>
                        :""}

                        {this.state.nodedata.end == "1" &&this.state.nodedata.endtype != "0" && this.state.nodedata.endtype != "2" && typeof(this.state.nodedata.endtype) !="undefined" ?
                        <Panel header="超时策略" key="4">
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item label="接收超时时限">
                                        {getFieldDecorator('servicereceiveTimeout ', {
                                            initialValue: this.state.nodedata.receiveTimeout,
                                            rules: [{ required: false, message: '请输入超时时限' }],
                                        })(
                                            <InputNumber
                                                min={0}
                                                onChange={this.numberOnChange.bind(this, "servicereceiveTimeout")}
                                            />
                                        )}<span> 分钟</span>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="超时处理规则">
                                        {getFieldDecorator('servicetimeoutHandling', {
                                            rules: [{ required: false, message: '' }],
                                        })(
                                            <Select placeholder="请选择超时处理规则"
                                                onChange={this.selectOnChange.bind(this, 'servicetimeoutHandling')}
                                            >
                                                <Option value="01">不处理</Option>
                                                <Option value="02">补偿处理</Option>
                                                <Option value="03">向创建人发消息</Option>
                                                <Option value="04">回退处理</Option>
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            {
                                this.state.nodedata.timeoutHandling == "02" ?
                                    (<Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label="补偿执行次数">
                                                {getFieldDecorator('serviceredoTime', {
                                                    initialValue: this.state.nodedata.redoTime,
                                                    rules: [{ required: false, message: '请输入补偿执行次数' }],
                                                })(
                                                    <InputNumber
                                                        min={0}
                                                        onChange={this.numberOnChange.bind(this, "serviceredoTime")}
                                                    />
                                                )}<span> 次</span>
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label="补偿执行周期">
                                                {getFieldDecorator('serviceredoCycle', {
                                                    initialValue: this.state.nodedata.redoCycle,
                                                    rules: [{ required: false, message: '请选择补偿执行周期' }],
                                                })(
                                                    <Select placeholder="请选择补偿执行周期"
                                                        onChange={this.selectOnChange.bind(this, 'serviceredoCycle')}
                                                    >
                                                        <Option value="01">不重复</Option>
                                                        <Option value="02">每10分钟</Option>
                                                        <Option value="03">每30分钟</Option>
                                                        <Option value="04">每60分钟</Option>
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>) // 补偿处理显示内容
                                    :
                                    (null) // 不显示内容
                            }
                        </Panel>

                        :""}                           

                        {this.state.nodedata.end == "1" &&this.state.nodedata.endtype != "0" && this.state.nodedata.endtype != "1" && typeof(this.state.nodedata.endtype) !="undefined" ?
                        <Panel header="脚本节点信息" key="5">
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item label="脚本类型">
                                        {getFieldDecorator('scripttype', {
                                            rules: [{ required: true, message: '请输入脚本类型' }],
                                        })(<RadioGroup onChange={this.radioGroupOnChange.bind(this, 'scripttype')} >
                                                <Radio value={"0"}>JavaScript</Radio>
                                                <Radio value={"1"}>JAVA</Radio>
                                            </RadioGroup>)}
                                    
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <div align="right">
                                        <Button size="small" onClick={this.handleAdd.bind(this, "scriptcallin")} type="primary" style={{ marginBottom: 10 }}>
                                            添加脚本输入
                                        </Button>
                                    </div>
                                    <Table size="small" rowKey={"_key"}
                                        rowClassName={() => 'incomeList-row'} // 表格行的类名
                                        bordered // 是否展示外边框和列边框
                                        dataSource={scriptcallinList}
                                        columns={scriptcallinListColumns}
                                    />
                                    <Modal
                                        title="添加脚本输入参数"
                                        visible={this.state.modalScriptInShow}
                                        onOk={this.scriptCallInHandleOk.bind(this)}
                                        onCancel={this.modalHandleCancel}
                                        okText="确认"
                                        cancelText="取消"
                                        destroyOnClose
                                    >
                                        <Form.Item label="输入参数key">
                                            <Input placeholder="输入参数key"
                                                onChange={this.modalOnChange.bind(this, 'inParamKey')}
                                            />
                                        </Form.Item>
                                        <Form.Item label="输入参数value">
                                            <Input placeholder="输入参数value"
                                                onChange={this.modalOnChange.bind(this, 'inParamValue')}
                                            />
                                        </Form.Item>
                                    </Modal>
                                </Col>
                            </Row>
                                    
                            <Row gutter={16}>
                                <Col span={24}>
                                    <div style={{color:"red"}}	>
                                        输出参数将保存在工作流的业务数据中
                                    </div>
                                    <div align="right">
                                        <Button size="small" onClick={this.handleAdd.bind(this, "scriptcallout")} type="primary" style={{ marginBottom: 10 }}>
                                            添加脚本输出
                                        </Button>
                                    </div>
                                    <Table size="small" rowKey={"_key"}
                                        rowClassName={() => 'incomeList-row'} // 表格行的类名
                                        bordered // 是否展示外边框和列边框
                                        dataSource={scriptcalloutList}
                                        columns={scriptcalloutListColumns}
                                    />
                                    <Modal
                                        title="添加脚本输出参数"
                                        visible={this.state.modalScriptOutShow}
                                        onOk={this.scriptCallOutHandleOk.bind(this)}
                                        onCancel={this.modalHandleCancel}
                                        okText="确认"
                                        cancelText="取消"
                                        destroyOnClose
                                    >
                                        <Form.Item label="输出参数key">
                                            <Input placeholder="输出参数key"
                                                onChange={this.modalOnChange.bind(this, 'outParamKey')}
                                            />
                                        </Form.Item>
                                        <Form.Item label="输出参数value">
                                            <Input placeholder="输出参数value"
                                                onChange={this.modalOnChange.bind(this, 'outParamValue')}
                                            />
                                        </Form.Item>
                                    </Modal>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item label="脚本内容">
                                    {getFieldDecorator('scriptcode', {
                                        rules: [{ required: false, message: '请输入脚本内容' }],
                                    })(<Input.TextArea rows={10} placeholder="请输入脚本内容"
                                        onChange={this.textOnChange.bind(this, 'scriptcode')}
                                    />)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Panel>
                        :""}
                        <Panel header="干预策略" key="9" >
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item label="人工干预">
                                        {getFieldDecorator('ishuman', {
                                            rules: [{ required: false, message: '' }],
                                        })(
                                            <RadioGroup onChange={this.radioGroupOnChange.bind(this, 'ishuman')} >
                                                <Radio value={"0"}>不允许</Radio>
                                                <Radio value={"1"}>允许</Radio>
                                            </RadioGroup>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
							{this.state.nodedata.ishuman == "1" ?
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item label="处理规则">
                                        {getFieldDecorator('handling', {
                                            rules: [{ required: false, message: '' }],
                                        })(
                                            <CheckboxGroup onChange={this.checkboxGroupOnChange.bind(this, 'handling')} >
                                                <Checkbox value={"01"}>完成工作流</Checkbox>
                                                <Checkbox value={"02"}>回退处理</Checkbox>
                                            </CheckboxGroup>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>:""}
							{this.state.nodedata.ishuman == "1" ?
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Button size="small" onClick={this.handleAdd.bind(this, "human")} type="primary" style={{ marginBottom: 10 }}>
                                        添加操作人员
									</Button>
                                    <Table size="small" rowKey={"_key"}
                                        rowClassName={() => 'userList-row'} // 表格行的类名
                                        bordered // 是否展示外边框和列边框
                                        dataSource={human}
                                        columns={interventionUserListColumns}
                                    />
                                </Col>
                            </Row>:""}
                        </Panel>
                    </Collapse>
                </Form>
                {this.state.modalContent}
            </div>
        )
    }
}

const EndNode = Form.create()(EndeNodeFrom);
export default EndNode;


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiFlow/Workflow/Component/EndNode.js